import numeral from "numeral"
let subFilter = value => {
	let roleString = "";
	if( value && value.length>4 ){
		roleString = value.substr(0,4)+'...'
	}else{
		roleString = value
	}
	return roleString
}
export {subFilter}
// export default roleFilter

/*
	保留正数 小数点前几位 后几位格式化
	params
		:start | 小数点前几位 default 13
		:end   | 小数点后几位 default 2
*/
export function numberFormat(val, params = {start: 13,end:2}){
	val = val.replace(/[^\d.]/g, "") //清除"数字"和"."以外的字符
	val = val.replace(/^\./g, "") //验证第一个字符是数字
	val = val.replace(/\.{2,}/g, ".") //只保留第一个, 清除多余的
	val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".")
	// 字符串 \ 需要转义 \\
	let reg = `^(-)*(\\d+)\\.(\\d{1,${params.end}}).*$`
	val = val.replace(new RegExp(reg), "$1$2.$3") // 保留几位小数
	val = val.indexOf(".") > 0 ? val.split(".")[0].substring(0, params.start) + "." + val.split(".")[1] : val.substring(0, params.start) // 保留小数点前几位
	if(val.indexOf(".") < 0 && val !=""){ //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
		if(val.substr(0, 1) == "0" && val.length == 2){
			val = parseFloat(val)
		}
	}	
	return val
}
/*
	千分位格式化
	format = "0,00.00" 千分位格式
	format = "0.00" 保留两位
*/
export function money(n, format="0,00.00", zeroFormat = true) {
	if (n && n !== "" && (!zeroFormat || n !== 0) ) {
		return numeral(n).format(format)
	} else {
		return n
	}
}